import React from 'react';
import Switch from 'react-switch';
import styled, { useTheme } from 'styled-components';

import { colors } from '../../../core';
import Text from '../Text';

// The react-switch library is built as cjs so this is probably a cjs compatibility issue for Rollup build configuration
// Workaround for libraries that are using CJS module for redirecting
// @ts-ignore
const ReactSwitch = Switch.default ? Switch.default : Switch;

export interface ToggleProps {
  checked?: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

const SwitchContainer = styled.div`
  align-items: center;
  display: flex;
`;

const StyledTextLeft = styled(Text)`
  padding-right: 6px;
`;

const StyledTextRight = styled(Text)`
  padding-left: 6px;
`;

const Toggle = ({ checked, onChange, ...switchProps }: ToggleProps) => {
  const theme = useTheme();

  return (
    <SwitchContainer>
      <StyledTextLeft noMargin>Off</StyledTextLeft>
      <ReactSwitch
        className="switch"
        onChange={onChange}
        checked={checked}
        checkedIcon={false}
        uncheckedIcon={false}
        height={26}
        handleDiameter={18}
        onColor={theme.toggleActiveColor || colors.primary}
        offColor={theme.toggleColor || colors.smoke}
        {...(switchProps as any)}
      />
      <StyledTextRight noMargin>On</StyledTextRight>
    </SwitchContainer>
  );
};

export default Toggle;
